/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './_style.scss';

import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';

import { userHasRole } from '../../services/role';
import { CheckUserRole } from '../CheckUserRole';
import { ROLES } from '../../constants/roles';
import * as MenuProtocoloAction from '../../store/ducks/protocolo/menu/actions';
import { redirectHandled } from '../../util/helper';

const Menu = () => {
  const history = useHistory();

  // const hash = window.location.hash ? window.location.hash.split('/') : '';
  // const hashUpper = hash[1].toUpperCase();
  // const shouldShowEnvioProtocolo = (
  //   userHasRole(ROLES[hashUpper].PROTOCOLO_PRINCIPAL)
  //   || userHasRole(ROLES[hashUpper].PROTOCOLO_COMPLEMENTO)
  //   || userHasRole(ROLES[hashUpper].PROTOCOLO_CANCELADO)
  //   || userHasRole(ROLES[hashUpper].PROTOCOLO_CONSIGNADO)
  //   || userHasRole(ROLES[hashUpper].PROTOCOLO_ORIGINAL)
  // );
  
  return (
    <div className="menu-protocolos">
      <CheckUserRole>
        <div className="menu-protocolos__box">
          <h2 className="menu-protocolos__box__title">Tipo de Consulta</h2>
          <Row>
            <Col sm={6} md={3} lg={2} className="menu-protocolos__box__item col-12">
              <div className="menu-protocolos__box__item__card" onClick={() => { redirectHandled(history, '/protocolo/consulta'); }}>
                <i className="nav-icon icon-home" />
                Consulta
              </div>
            </Col>
          </Row>
        </div>
      </CheckUserRole>
        <div className="menu-protocolos__box">
          <h2 className="menu-protocolos__box__title">Tipo de Protocolo</h2>
          <Row>
            <CheckUserRole>
              <Col sm={6} md={3} lg={2} className="menu-protocolos__box__item col-12">
                <div className="menu-protocolos__box__item__card" onClick={() => { redirectHandled(history, '/protocolo/envio/principal'); }}>
                  <i className="nav-icon icon-home" />
                  Principal
                </div>
              </Col>
            </CheckUserRole>
            <CheckUserRole>
              <Col sm={6} md={3} lg={2} className="menu-protocolos__box__item col-12">
                <div className="menu-protocolos__box__item__card" onClick={() => { redirectHandled(history, '/protocolo/envio/complemento'); }}>
                  <i className="nav-icon icon-home" />
                  Complemento ou Regularização
                </div>
              </Col>
            </CheckUserRole>
            <CheckUserRole>
              <Col sm={6} md={3} lg={2} className="menu-protocolos__box__item col-12">
                <div className="menu-protocolos__box__item__card" onClick={() => { redirectHandled(history, '/protocolo/envio/cancelado'); }}>
                  <i className="nav-icon icon-home" />
                  Cancelado ou Recusado
                </div>
              </Col>
            </CheckUserRole>
          </Row>
        </div>
    </div>
  );
};

// const hideButtonCanledOrRefused = (hash) => {
//   let modulesToRemove = ["CONVENIOS", "CORRESPONDENTE", "GESTAOPENDENCIAS"];
//   return modulesToRemove.includes(hash)
// }

const mapStateToProps = (state) => ({
  menuProtocolo: state.menuProtocolo,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(MenuProtocoloAction, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Menu);